export const getTotemFullName = (totem: { name?: string | null; number: number }): string =>
    totem.name ? `${totem.name} (#${totem.number})` : `TOTEM #${totem.number}`;

// Label shown on the delivery note (bon de livraison) for a freefood delivery:
// "{organizationName} #{number} ({totem name})", omitting the parenthesised
// totem name when it is missing.
export const getDeliveryNoteTotemLabel = ({
    organizationName,
    number,
    name,
}: {
    organizationName?: string | null;
    number?: number | null;
    name?: string | null;
}): string => {
    const base = `${organizationName ?? ''} #${number ?? ''}`.trim();
    return name ? `${base} (${name})` : base;
};
